import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Default shell for CalCAP / small-business-style programs (non-CSP).
 */
export function SmallBusinessApplicationDetailsForm({ children, className = '' }: Props) {
  return (
    <div
      className={`application-details-form application-details-form--small-business ${className}`.trim()}
      data-application-details-program="smallBusiness"
    >
      {children}
    </div>
  );
}

export default SmallBusinessApplicationDetailsForm;
